/* eslint-disable max-len */
import Home from '../Containers/Home/Home';
import ConsultaElectores from '../Containers/ConsultaElectores/ConsultaElectores';
import RegistroGestores from '../Containers/RegistroGestores/RegistroGestores';
import Login from '../Containers/Login/Login';
import ForgotPassword from '../Containers/Login/ForgotPassword';
import MainPage from '../Containers/MainPage/MainPage';
import Formulario from '../Containers/Formulario/Formulario';
import FormularioAuth from '../Containers/FormularioAuth/FormularioAuth';
import Dashboard from '../Containers/Dashboard/Dashboard';
import Distritales from '../Containers/Distritales/Distritales';
import AddDistritales from '../Containers/Distritales/AddDistritales';
import Cantonales from '../Containers/Cantonales/Cantonales';
import EditCantonales from '../Containers/Cantonales/EditCantonales';
import AddCantonales from '../Containers/Cantonales/AddCantonales';
import Provinciales from '../Containers/Provinciales/Provinciales';
import AddProvinciales from '../Containers/Provinciales/AddProvinciales';
import EditProvinciales from '../Containers/Provinciales/EditProvinciales';
import PresidencialSectorial from '../Containers/PresidencialSectorial/PresidencialSectorial';
import AddPresidenteSector from '../Containers/PresidencialSectorial/AddPresidenteSector';
import EditPresidenteSector from '../Containers/PresidencialSectorial/EditPresidenteSector';
import Sectoriales from '../Containers/Sectoriales/Sectoriales';
import AddPapeletaSector from '../Containers/Sectoriales/AddPapeletaSector';
import EditSectoriales from '../Containers/Sectoriales/EditSectoriales';
import Nacionales from '../Containers/Nacionales/Nacionales';
import AddNacionales from '../Containers/Nacionales/AddNacionales';
import EditNacionales from '../Containers/Nacionales/EditNacionales';
import EditDistritales from '../Containers/Distritales/EditDistritales';

import MiembrosMesa from '../Containers/MiembrosMesa/MiembrosMesa';
import AddMiembro from '../Containers/MiembrosMesa/AddMiembro';
import EditMiembro from '../Containers/MiembrosMesa/EditMiembro';

import FiscalesMesa from '../Containers/FiscalesMesa/FiscalesMesa';
import AddFiscales from '../Containers/FiscalesMesa/AddFiscales';
import EditFiscales from '../Containers/FiscalesMesa/EditFiscales';

import FiscalesGenerales from '../Containers/FiscalesGenerales/FiscalesGenerales';
import AddFiscalesGenerales from '../Containers/FiscalesGenerales/AddFiscalesGenerales';
import EditFiscalesGenerales from '../Containers/FiscalesGenerales/EditFiscalesGenerales';

import RegistroDepositos from '../Containers/RegistroDepositos/RegistroDepositos';
import AddDeposito from '../Containers/RegistroDepositos/AddDeposito';
import EditDeposito from '../Containers/RegistroDepositos/EditDeposito';

import ConsultaDebitos from '../Containers/ConsultaDebitos/ConsultaDebitos';

// Consultas Publicas
import CPPapeletasDistritales from '../Containers/ConsultasPublicas/CPPapeletasDistritales';
import CPPapeletasCantonales from '../Containers/ConsultasPublicas/CPPapeletasCantonales';
import CPPapeletasProvinciales from '../Containers/ConsultasPublicas/CPPapeletasProvinciales';
import CPPapeletasNacionales from '../Containers/ConsultasPublicas/CPPapeletasNacionales';
import CPPresidenteSector from '../Containers/ConsultasPublicas/CPPresidenteSector';
import CPPapeletasSectoriales from '../Containers/ConsultasPublicas/CPPapeletasSectoriales';
import REMiembrosMesa from '../Containers/RegistrosElectorales/REMiembrosMesa';
import REFiscalesMesa from '../Containers/RegistrosElectorales/REFiscalesMesa';
import REFiscalesGenerales from '../Containers/RegistrosElectorales/REFiscalesGenerales';

// Reporte de Resultados
import EVConvencionInterna from '../Containers/EscrutinioVotacion/EVConvencionInterna';
import EVPapeletasDistritales from '../Containers/EscrutinioVotacion/EVPapeletasDistritales';
import EVPapeletasCantonales from '../Containers/EscrutinioVotacion/EVPapeletasCantonales';
import EVPapeletasProvinciales from '../Containers/EscrutinioVotacion/EVPapeletasProvinciales';
import EVPapeletasNacionales from '../Containers/EscrutinioVotacion/EVPapeletasNacionales';

/*
import EVPresidenteSector from '../Containers/EscrutinioVotacion/EVPresidenteSector';
import EVPapeletasSectoriales from '../Containers/EscrutinioVotacion/EVPapeletasSectoriales';
*/

// Reporte de Adjudicación de Puestos
import APDelegadosDistritales from '../Containers/AdjudicacionPuestos/APDelegadosDistritales';
import APComitePoliticoCantonal from '../Containers/AdjudicacionPuestos/APComitePoliticoCantonal';
import APMovRepresentanteProvincial from '../Containers/AdjudicacionPuestos/APMovRepresentanteProvincial';
import APMovimientosNacionales from '../Containers/AdjudicacionPuestos/APMovimientosNacionales';
/*
import APPresidenteSector from '../Containers/AdjudicacionPuestos/APPresidenteSector';
*/
import APSectores from '../Containers/AdjudicacionPuestos/APSectores';

// Gafetes Electorales
import GafetesMiembrosMesa from '../Containers/GafetesElectorales/GafetesMiembrosMesa';
import GafetesFiscalesMesa from '../Containers/GafetesElectorales/GafetesFiscalesMesa';
import GafetesFiscalesGenerales from '../Containers/GafetesElectorales/GafetesFiscalesGenerales';

const routesList = [
  {
    auth: false,
    component: MainPage,
    exact: true,
    name: 'mainPage',
    path: '/',
  },
  {
    auth: false,
    component: Login,
    exact: true,
    name: 'login',
    path: '/login',
  },
  {
    auth: false,
    component: ForgotPassword,
    exact: true,
    name: 'forgotPwd',
    path: '/forgot-password',
  },
  {
    auth: true,
    component: Home,
    exact: true,
    name: 'home',
    path: '/home',
  },
  {
    auth: true,
    component: Dashboard,
    exact: true,
    name: 'dashboard',
    path: '/dashboard',
  },
  {
    auth: true,
    component: Distritales,
    exact: true,
    name: 'distritales',
    path: '/distritales',
  },
  {
    auth: true,
    component: AddDistritales,
    exact: true,
    name: 'addDistritales',
    path: '/distritales/add',
  },
  {
    auth: true,
    component: EditDistritales,
    exact: true,
    name: 'editDistritales',
    path: '/distritales/edit/:id',
  },
  {
    auth: true,
    component: Cantonales,
    exact: true,
    name: 'cantonales',
    path: '/cantonales',
  },
  {
    auth: true,
    component: AddCantonales,
    exact: true,
    name: 'addCantonales',
    path: '/cantonales/add',
  },
  {
    auth: true,
    component: EditCantonales,
    exact: true,
    name: 'editCantonales',
    path: '/cantonales/edit/:id',
  },
  {
    auth: true,
    component: Nacionales,
    exact: true,
    name: 'nacionales',
    path: '/nacionales',
  },
  {
    auth: true,
    component: AddNacionales,
    exact: true,
    name: 'addNacionales',
    path: '/nacionales/add',
  },
  {
    auth: true,
    component: EditNacionales,
    exact: true,
    name: 'editNacionales',
    path: '/nacionales/edit/:id',
  },
  {
    auth: true,
    component: Provinciales,
    exact: true,
    name: 'provinciales',
    path: '/provinciales',
  },
  {
    auth: true,
    component: AddProvinciales,
    exact: true,
    name: 'addProvinciales',
    path: '/provinciales/add',
  },
  {
    auth: true,
    component: EditProvinciales,
    exact: true,
    name: 'editProvinciales',
    path: '/provinciales/edit/:id',
  },
  {
    auth: true,
    component: PresidencialSectorial,
    exact: true,
    name: 'presiSectores',
    path: '/presi-sectores',
  },
  {
    auth: true,
    component: AddPresidenteSector,
    exact: true,
    name: 'addPresiSector',
    path: '/presi-sectores/add',
  },
  {
    auth: true,
    component: EditPresidenteSector,
    exact: true,
    name: 'editPresiSector',
    path: '/presi-sectores/edit/:id',
  },
  {
    auth: true,
    component: Sectoriales,
    exact: true,
    name: 'sectoriales',
    path: '/sectoriales',
  },
  {
    auth: true,
    component: AddPapeletaSector,
    exact: true,
    name: 'addPapeletaSector',
    path: '/sectoriales/add',
  },
  {
    auth: true,
    component: EditSectoriales,
    exact: true,
    name: 'editSectoriales',
    path: '/sectoriales/edit/:id',
  },
  {
    auth: true,
    component: MiembrosMesa,
    exact: true,
    name: 'miembros-mesa',
    path: '/miembros-mesa',
  },
  {
    auth: true,
    component: AddMiembro,
    exact: true,
    name: 'miembros-mesa-add',
    path: '/miembros-mesa/add',
  },
  {
    auth: true,
    component: EditMiembro,
    exact: true,
    name: 'miembros-mesa-edit',
    path: '/miembros-mesa/edit/:id',
  },
  {
    auth: true,
    component: FiscalesMesa,
    exact: true,
    name: 'fiscales-mesa',
    path: '/fiscales-mesa',
  },
  {
    auth: true,
    component: AddFiscales,
    exact: true,
    name: 'fiscales-mesa-add',
    path: '/fiscales-mesa/add',
  },
  {
    auth: true,
    component: EditFiscales,
    exact: true,
    name: 'fiscales-mesa-edit',
    path: '/fiscales-mesa/edit/:id',
  },
  {
    auth: true,
    component: FiscalesGenerales,
    exact: true,
    name: 'fiscales-generales',
    path: '/fiscales-generales',
  },
  {
    auth: true,
    component: AddFiscalesGenerales,
    exact: true,
    name: 'fiscales-generales-add',
    path: '/fiscales-generales/add',
  },
  {
    auth: true,
    component: EditFiscalesGenerales,
    exact: true,
    name: 'fiscales-generales-edit',
    path: '/fiscales-generales/edit/:id',
  },
  {
    auth: false,
    component: Formulario,
    exact: true,
    name: 'formulario',
    path: '/formulario/:typeForm',
  },
  {
    auth: true,
    component: FormularioAuth,
    exact: true,
    name: 'formularioAuth',
    path: '/formularioAuth/:typeForm',
  },
  {
    auth: false,
    component: ConsultaElectores,
    exact: true,
    name: 'consulta-electores',
    path: '/consulta-electores',
  },
  {
    auth: false,
    component: RegistroGestores,
    exact: true,
    name: 'registro-gestores',
    path: '/registro-gestores',
  },
  {
    auth: true,
    component: RegistroDepositos,
    exact: true,
    name: 'registroDepositos',
    path: '/registro-depositos',
  },
  {
    auth: true,
    component: AddDeposito,
    exact: true,
    name: 'addDeposito',
    path: '/registro-depositos/add',
  },
  {
    auth: true,
    component: EditDeposito,
    exact: true,
    name: 'editDeposito',
    path: '/registro-depositos/edit/:id',
  },
  {
    auth: true,
    component: ConsultaDebitos,
    exact: true,
    name: 'consultaDebitos',
    path: '/consulta-debitos',
  },
  {
    auth: false,
    component: EVConvencionInterna,
    exact: true,
    name: 'evConvencionInterna',
    path: '/escrutinio-votacion/convencion-interna',
  },
  {
    auth: false,
    component: EVPapeletasDistritales,
    exact: true,
    name: 'evPapeletasDistritales',
    path: '/escrutinio-votacion/papeletas-distritales',
  },
  {
    auth: false,
    component: EVPapeletasCantonales,
    exact: true,
    name: 'evPapeletasCantonales',
    path:
      '/escrutinio-votacion/papeletas-movimientos-cantonales',
  },
  {
    auth: false,
    component: EVPapeletasProvinciales,
    exact: true,
    name: 'evPapeletasProvinciales',
    path:
      '/escrutinio-votacion/papeletas-movimientos-provinciales',
  },
  {
    auth: false,
    component: EVPapeletasNacionales,
    exact: true,
    name: 'evPapeletasNacionales',
    path:
      '/escrutinio-votacion/papeletas-movimientos-nacionales',
  },
  /*
  {
    auth: false,
    component: EVPresidenteSector,
    exact: true,
    name: 'evPresidenteSector',
    path: '/escrutinio-votacion/presidente-sectores',
  },
  {
    auth: false,
    component: EVPapeletasSectoriales,
    exact: true,
    name: 'evPapeletasSectoriales',
    path: '/escrutinio-votacion/papeletas-sectores',
  },
  */
  {
    auth: false,
    component: APDelegadosDistritales,
    exact: true,
    name: 'apDelegadosDistritales',
    path: '/adjudicacion-puestos/delegados-distritales',
  },
  {
    auth: false,
    component: APComitePoliticoCantonal,
    exact: true,
    name: 'apComitePoliticoCantonal',
    path: '/adjudicacion-puestos/comite-politico-cantonal',
  },
  {
    auth: false,
    component: APMovRepresentanteProvincial,
    exact: true,
    name: 'apMovRepresentanteProvincial',
    path:
      '/adjudicacion-puestos/movimiento-representante-provinciales',
  },
  {
    auth: false,
    component: APMovimientosNacionales,
    exact: true,
    name: 'apMovimientosNacionales',
    path: '/adjudicacion-puestos/movimientos-nacionales',
  },
  /*
  {
    auth: false,
    component: APPresidenteSector,
    exact: true,
    name: 'apPresidenteSector',
    path: '/adjudicacion-puestos/presidente-sectores',
  },
  */
  {
    auth: false,
    component: APSectores,
    exact: true,
    name: 'apSectores',
    path: '/adjudicacion-puestos/sectores',
  },

  {
    auth: false,
    component: CPPapeletasDistritales,
    exact: true,
    name: 'cpPapeletasDistritales',
    path: '/consulta-publica/papeletas-distritales',
  },
  {
    auth: false,
    component: CPPapeletasCantonales,
    exact: true,
    name: 'cpPapeletasCantonales',
    path:
      '/consulta-publica/papeletas-movimientos-cantonales',
  },
  {
    auth: false,
    component: CPPapeletasProvinciales,
    exact: true,
    name: 'cpPapeletasProvinciales',
    path:
      '/consulta-publica/papeletas-movimientos-provinciales',
  },
  {
    auth: false,
    component: CPPapeletasNacionales,
    exact: true,
    name: 'cpPapeletasNacionales',
    path:
      '/consulta-publica/papeletas-movimientos-nacionales',
  },
  {
    auth: false,
    component: CPPresidenteSector,
    exact: true,
    name: 'cpPresidenteSector',
    path: '/consulta-publica/presidente-sectores',
  },
  {
    auth: false,
    component: CPPapeletasSectoriales,
    exact: true,
    name: 'cpPapeletasSectoriales',
    path: '/consulta-publica/papeletas-sectores',
  },
  {
    auth: false,
    component: REMiembrosMesa,
    exact: true,
    name: 'reMiembrosMesa',
    path: '/registros-electorales/miembros-mesa',
  },
  {
    auth: false,
    component: REFiscalesMesa,
    exact: true,
    name: 'reFiscalesMesa',
    path: '/registros-electorales/fiscales-mesa',
  },
  {
    auth: false,
    component: REFiscalesGenerales,
    exact: true,
    name: 'reFiscalesGenerales',
    path: '/registros-electorales/fiscales-generales',
  },
  {
    auth: true,
    component: GafetesMiembrosMesa,
    exact: true,
    name: 'gafetes-miembros-mesa',
    path: '/gafetes-miembros-mesa',
  },
  {
    auth: true,
    component: GafetesFiscalesMesa,
    exact: true,
    name: 'gafetes-fiscales-mesa',
    path: '/gafetes-fiscales-mesa',
  },
  {
    auth: true,
    component: GafetesFiscalesGenerales,
    exact: true,
    name: 'gafetes-fiscales-generales',
    path: '/gafetes-fiscales-generales',
  },
];

export default routesList;
